import api from './api'

export const spkService = {
  // Get all SPK with filters
  getAll: async (params = {}) => {
    const response = await api.get('/spk', { params })
    return response.data
  },

  // Get SPK by ID
  getById: async (id) => {
    const response = await api.get(`/spk/${id}`)
    return response.data
  },

  // Create SPK
  create: async (data) => {
    const response = await api.post('/spk', data)
    return response.data
  },

  // Update SPK
  update: async (id, data) => {
    const response = await api.put(`/spk/${id}`, data)
    return response.data
  },

  // Delete SPK
  delete: async (id) => {
    const response = await api.delete(`/spk/${id}`)
    return response.data
  },

  // Update station
  updateStation: async (id, data) => {
    const response = await api.put(`/spk/${id}/station`, data)
    return response.data
  },

  // Update custom school station
  updateCustomStation: async (id, data) => {
    const response = await api.put(`/spk/${id}/custom-station`, data)
    return response.data
  },

  // Create batch
  createBatch: async (id, data) => {
    const response = await api.post(`/spk/${id}/batches`, data)
    return response.data
  },

  // Update batch station
  updateBatchStation: async (id, batchId, data) => {
    const response = await api.put(`/spk/${id}/batches/${batchId}/station`, data)
    return response.data
  },

  // Mark batching complete
  markBatchingComplete: async (id, data) => {
    const response = await api.post(`/spk/${id}/batching-complete`, data)
    return response.data
  },

  // Confirm completion (manager)
  confirmCompletion: async (id) => {
    const response = await api.post(`/spk/${id}/confirm-completion`)
    return response.data
  },

  // Add print info
  addPrintInfo: async (id, data) => {
    const response = await api.post(`/spk/${id}/print-info`, data)
    return response.data
  },

  // Update existing print info
  updatePrintInfo: async (id, printId, data) => {
    const response = await api.put(`/spk/${id}/print-info/${printId}`, data)
    return response.data
  },

  // Add QC result
  addQCResult: async (id, data) => {
    const response = await api.post(`/spk/${id}/qc`, data)
    return response.data
  },

  // Update QC result
  updateQCResult: async (id, qcId, data) => {
    const response = await api.put(`/spk/${id}/qc/${qcId}`, data)
    return response.data
  },

  // Update batch QC
  updateBatchQC: async (id, batchId, data) => {
    const response = await api.put(`/spk/${id}/batches/${batchId}/qc`, data)
    return response.data
  },

  // Add warehouse entry
  addWarehouseEntry: async (id, data) => {
    const response = await api.post(`/spk/${id}/warehouse`, data)
    return response.data
  },

  // Rollback station (admin only)
  rollbackStation: async (id, data) => {
    const response = await api.post(`/spk/${id}/rollback-station`, data)
    return response.data
  },

  // Rollback batch station (admin only)
  rollbackBatchStation: async (id, batchId, data) => {
    const response = await api.post(`/spk/${id}/batches/${batchId}/rollback-station`, data)
    return response.data
  },

  // Comcolor operator queue
  getComcolorQueue: async () => {
    const response = await api.get('/spk/comcolor-queue')
    return response.data
  },

  // Complete comcolor print (skip susun)
  completeComcolor: async (id, data) => {
    const response = await api.post(`/spk/${id}/comcolor-complete`, data)
    return response.data
  }
}

export default spkService
